$(document).ready(function () {
    var icons = {
        header: "ui-icon-plus",
        activeHeader: "ui-icon-minus"
    };
    $( ".rolex-accordion" ).accordion({
        heightStyle: "content",
        icons: icons
    });
});